import { Hint } from "../../odc-ui";
import styled from "styled-components/macro";
import { Frame } from "@bitesite/react-figstrap";

const InlineHint = styled(Hint)`
  margin-left: ${(props) => `${props.marginLeft ? props.marginLeft : "0"}px`};
  top: 3px;
`;

const LabelWithHintFrame = styled(Frame)`
  display: block;
`;

export { InlineHint, LabelWithHintFrame };
